import {axiosInstance as mantis} from "src/api/mantis";
import {DOMAIN_APPROVAL} from "src/constants";

export const decodeCsr = (orderId, csr) => {
    const params = {params: {csr}};
    return mantis.get(`/order/${orderId}/validation/csr`, params);
};

export const getOrderDetails = orderId => {
    return mantis.get(`/order/${orderId}`);
};

export const getOrderProviderDetails = orderId => {
    return mantis.get(`/order/${orderId}/provider`);
};

export const getOrderCsr = orderId => {
    return mantis.get(`/order/${orderId}/csr`);
};

export const orderCertificate = (orderId, csr, dcv, webserver, approvers, uniqueId, organization, adminContact) => {
    const organizationData = organization
        ? {
            id: organization.id,
            organization: organization.organization,
            locality: organization.locality,
            addressLine: organization.address,
            postalCode: organization.postalCode,
            state: organization.state,
            country: organization.country,
            phone: organization.phone
        }
        : null;

    const adminContactData = adminContact
        ? {
            title: adminContact.title,
            firstName: adminContact.firstName,
            lastName: adminContact.lastName,
            email: adminContact.email,
            phone: adminContact.phone
        }
        : null;

    const data = {webServer: webserver, csr, dcv, organization: organizationData, adminContact: adminContactData};

    if (dcv === DOMAIN_APPROVAL.email.key) {
        data.approvers = approvers;
        data.dcv = DOMAIN_APPROVAL.email.value;
    } else if (dcv === DOMAIN_APPROVAL.dns.key) {
        data.uniqueId = uniqueId;
        data.dcv = DOMAIN_APPROVAL.dns.value;
    } else if (dcv === DOMAIN_APPROVAL.dnsauto.key) {
        data.dcv = DOMAIN_APPROVAL.dnsauto.value;
    }

    return mantis.post(`/order/${orderId}/certificate`, data);
};

export const reissueCertificate = (orderId, csr, dcv, approvers, uniqueId) => {
    const data = {csr, dcv};

    if (dcv === DOMAIN_APPROVAL.email.key) {
        data.approvers = approvers;
        data.dcv = DOMAIN_APPROVAL.email.value;
    } else if (dcv === DOMAIN_APPROVAL.dns.key) {
        data.uniqueId = uniqueId;
        data.dcv = DOMAIN_APPROVAL.dns.value;
    } else if (dcv === DOMAIN_APPROVAL.dnsauto.key) {
        data.dcv = DOMAIN_APPROVAL.dnsauto.value;
    }

    return mantis.put(`/order/${orderId}/certificate`, data);
};

export const cancelCertificateOrder = (orderId, data) => {
    return mantis.delete(`/order/${orderId}/certificate`);
};

export const downloadCertificate = orderId => {
    return mantis.get(`/order/${orderId}/certificate`);
};

export const getEmailApprovers = (orderId, csr) => {
    const params = {params: {csr}};
    return mantis.get(`/order/${orderId}/validation/email`, params);
};

export const getDnsValidation = (orderId, csr) => {
    const params = {params: {csr}};
    return mantis.get(`/order/${orderId}/validation/dns`, params);
};

export const getOrderAvailableTenantList = orderId => {
    return mantis.get(`/order/${orderId}/tenant/available`);
};

export const updateOrder = (orderId, parentTenantId) => {
    const data = {parentTenantId};
    return mantis.patch(`/order/${orderId}`, data);
};
